import { type NewsOptions, type NewsType, type NewsTypeFront } from '@Types/Blocks/News';
import { type QueryPost } from '@Types/Shared/Query';

import Decorations from '../../_components/Decorations';
import NewsClassic from './variants/Classic';
import NewsTagImg from './variants/TagImg';
import NewsTitleImg from './variants/TitleImg';

export type NewsProps = Omit<
	NewsType & NewsOptions,
	'block_theme' | 'posts' | 'order' | 'orderBy' | 'isManual'
> & { posts: QueryPost[]; linkIndex: string };

export const News = (props: NewsProps) => {
	const {
		description,
		postsNumber,
		style = {},
		context = 'news',
		ctasStyle,
		placement,
		sectionDecoration,
	} = props;

	const NewsTypeModel: NewsTypeFront = {
		id: props.id,
		title: props.title,
		context: context,
		description: description,
		titleFormat: props.titleFormat,
		textLabel: props.textLabel,
		posts: props.posts,
		postNumber: postsNumber,
		headingAlign: props.headingAlign,
		containerType: props.containerType,
		variant: props.variant,
		cardType: props.cardType,
		archiveLink: props.archiveLink,
		linkIndex: props.linkIndex,
		readMoreHasIcon: props.readMoreHasIcon,
		readMoreDecorationElement: props.readMoreDecorationElement,
		contentFontFormats: props.contentFontFormats,
		archiveLinkStyles: props.archiveLinkStyles,
		displayDate: props.displayDate,
		displayExcerpt: props.displayExcerpt,
		displayTag: props.displayTag,
		sectionDecoration: sectionDecoration,
		headingFontClassName: {
			title: 'minos-news-heading-title-font-style tablet:minos-news-heading-title-font-style',
			text: {
				p: 'minos-news-heading-description-font-style text-base tablet:minos-news-heading-description-font-style my-4',
				a: {
					style: 'a',
					btnHasIcon: ctasStyle?.a?.btnHasIcon ? ctasStyle?.a?.btnHasIcon : false,
					btnDecorationElement: 'underline',
					aClassname: 'minos-news-btn-a text-base tablet:minos-news-btn-a',
				},
				btnPrimary: {
					style: 'primary',
					btnHasIcon: ctasStyle?.primary?.btnHasIcon ? ctasStyle?.primary?.btnHasIcon : false,
					btnDecorationElement: ctasStyle?.primary?.btnDecorationElement
						? ctasStyle?.primary?.btnDecorationElement
						: 'short',
					primaryClassname: 'minos-news-btn-primary tablet:minos-news-btn-primary my-2 mr-4',
					animation: ctasStyle?.primary?.animation ? ctasStyle?.primary?.animation : 'none',
				},
				btnSecondary: {
					style: 'secondary',
					btnHasIcon: ctasStyle?.secondary?.btnHasIcon ? ctasStyle?.secondary?.btnHasIcon : false,
					btnDecorationElement: ctasStyle?.secondary?.btnDecorationElement
						? ctasStyle?.secondary?.btnDecorationElement
						: 'short',
					secondaryClassname: 'minos-news-btn-secondary tablet:minos-news-btn-secondary my-2 mr-4',
					animation: ctasStyle?.secondary?.animation ? ctasStyle?.secondary?.animation : 'none',
				},
				btnTertiary: {
					style: 'tertiary',
					btnHasIcon: ctasStyle?.tertiary?.btnHasIcon ? ctasStyle?.tertiary?.btnHasIcon : false,
					btnDecorationElement: ctasStyle?.tertiary?.btnDecorationElement
						? ctasStyle?.tertiary?.btnDecorationElement
						: 'short',
					tertiaryClassname: 'minos-news-btn-tertiary tablet:minos-news-btn-tertiary',
					animation: ctasStyle?.tertiary?.animation ? ctasStyle?.tertiary?.animation : 'none',
				},
			},
		},
		contentFontClass: {
			postTitle:
				'minos-news-inside-title-font-style text-2xl  tablet:minos-news-inside-title-font-style',
			excerpt:
				'minos-news-inside-description-font-style text-base tablet:minos-news-inside-description-font-style',
			postInfo: 'minos-news-post-info-font-style text-sm tablet:minos-news-post-info-font-style',
			readMore: 'minos-news-readMore-font-style text-base tablet:minos-news-readMore-font-style',
		},
	};

	const variations = {
		classic: <NewsClassic {...NewsTypeModel} />,
		titleImg: <NewsTitleImg {...NewsTypeModel} />,
		tagImg: <NewsTagImg {...NewsTypeModel} />,
	};

	return (
		<>
			<section className='relative' data-variant={`news-${props.variant}`} style={style}>
				<Decorations
					isSectionDecorated={sectionDecoration?.isSectionDecorated}
					type={sectionDecoration?.type}
					pathClassName={`${sectionDecoration?.type === 'wave' ? 'fill-minos-news-bg-color' : 'fill-minos-decoration-bubble-left'}`}
					pathClassNameRightCircle={`${sectionDecoration?.type === 'bubble' && 'fill-minos-decoration-bubble-right'}`}
					placement={placement}
				>
					{variations[props.variant]}
				</Decorations>
			</section>
		</>
	);
};

export default News;
